const NO_FN_EXPECTED = `As such, no LivePerson engagement or 'click to chat' functionality should be expected.`;

export default {
	LIVE_PERSON: {
		BUTTON: 'Click to start live chat',
	},

	LP_TAG: {
		ERROR: `An error occured with LivePerson tag (LPTag). This pertains to the 'Click to chat' functionality within the 'Footer' sub-component 'ContactUsBar'.\n\n${NO_FN_EXPECTED}`,
		DOESNT_EXIST: `LivePerson tag (LPTag) was not found on the window. This pertains to the 'Click to chat' functionality within the 'Footer' sub-component 'ContactUsBar'.\n\n${NO_FN_EXPECTED}`,
	},

	SITECORE: {
		INACTIVE: `LivePerson is not initialised in Sitecore's Experience Editor. ${NO_FN_EXPECTED}`,

		EE: {
			STATUS_MESSAGES: 'Status messages',
			LIVE_PERSON_INACTIVE:
				"LivePerson (click-to-chat) is disabled in Sitecore's Experience Editor.",
		},
	},
};
